export default "__VITE_ASSET__85XL6Gnc__"